import { Box, Button, Paper, Stack } from "@mui/material";
import FieldLabel from "../atoms/FieldLabel";
import AddIcon from "@mui/icons-material/Add";
import FormInput from "./FormInput";
import { useTranslation } from "react-i18next";
import DeleteButton from "../atoms/DeleteButton";
import { HttpHeader } from "../../services/swagger";

interface HttpHeaderListProps {
  value: HttpHeader[];
  onChange: (value: HttpHeader[]) => void;
  loading?: boolean;
}

export default function HttpHeaderList(props: HttpHeaderListProps) {
  const { t } = useTranslation("HttpHeaderList");
  const { value, onChange } = props;

  const handleAddHeader = () => {
    onChange([...value, { name: `Header-${value.length + 1}`, value: "" }]);
  };

  const handleDeleteHeader = (index: number) => {
    const newHeaders = [...value];
    newHeaders.splice(index, 1);
    onChange(newHeaders);
  };

  return (
    <Stack spacing={1}>
      <FieldLabel>{t("HttpHeaders")}</FieldLabel>
      {value.map((header, index) => (
        <Paper
          key={index}
          sx={{ p: 2, bgcolor: "background.default", maxWidth: 700 }}
        >
          <Stack direction="row" spacing={1} alignItems="flex-end">
            <Box>
              <FormInput
                required
                type="string"
                field={`header-${index}-name`}
                label={t("HeaderName")}
                value={header.name}
                onChange={(v) => {
                  const newHeaders = [...value];
                  newHeaders[index] = {
                    ...newHeaders[index],
                    name: v as string,
                  };
                  onChange(newHeaders);
                }}
                loading={props.loading}
              />
            </Box>
            <FormInput
              type="string"
              field={`header-${index}-value`}
              label={t("HeaderValue")}
              value={header.value}
              onChange={(v) => {
                const newHeaders = [...value];
                newHeaders[index] = {
                  ...newHeaders[index],
                  value: v as string,
                };
                onChange(newHeaders);
              }}
              loading={props.loading}
            />
            <DeleteButton
              size={41.7}
              onClick={() => handleDeleteHeader(index)}
              loading={props.loading}
            />
          </Stack>
        </Paper>
      ))}
      <Button
        sx={{ width: "fit-content" }}
        size="small"
        startIcon={<AddIcon />}
        onClick={handleAddHeader}
        loading={props.loading}
      >
        {t("AddHeader")}
      </Button>
    </Stack>
  );
}
